export class ApplicationBorrowerApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async createBorrower({ applicationId, withLoanOptionId, ...body }) {
    return this.#http.post(`/application/${applicationId}/borrower`, body, {
      params: { withLoanOptionId },
    });
  }

  async deleteBorrower({ applicationId, borrowerId, withLoanOptionId, tabId }) {
    return this.#http.delete(`/application/${applicationId}/borrower/${borrowerId}`, {
      params: { withLoanOptionId, tabId },
    });
  }

  async editBorrowerPersonalInfo({ applicationId, borrowerId, withLoanOptionId, ...body }) {
    return this.#http.put(
      `/application/${applicationId}/borrower/${borrowerId}/personal-info`,
      body,
      {
        params: { withLoanOptionId },
      },
    );
  }

  async editBorrowerDeclarations({
    applicationId,
    borrowerId,
    withLoanOptionId,
    declarationType,
    ...body
  }) {
    return this.#http.put(
      `/application/${applicationId}/borrower/${borrowerId}/declarations`,
      body,
      {
        params: { withLoanOptionId, declarationType },
      },
    );
  }

  async deleteBorrowerMailingAddress({ applicationId, borrowerId, tabId, withLoanOptionId }) {
    return this.#http.delete(
      `/application/${applicationId}/borrower/${borrowerId}/mailingAddress`,
      { params: { tabId, withLoanOptionId } },
    );
  }

  async editBorrowerMailingAddress({ applicationId, borrowerId, withLoanOptionId, ...body }) {
    return this.#http.put(
      `/application/${applicationId}/borrower/${borrowerId}/mailingAddress`,
      body,
      {
        params: { withLoanOptionId },
      },
    );
  }

  async createBorrowerMailingAddress({ applicationId, borrowerId, withLoanOptionId, ...body }) {
    return this.#http.post(
      `/application/${applicationId}/borrower/${borrowerId}/mailingAddress`,
      body,
      {
        params: { withLoanOptionId },
      },
    );
  }

  async bulkUpdateBorrowers({ applicationId, body }) {
    return this.#http.put(`/applications/${applicationId}/borrowers/bulk-update`, body, {
      params: {
        tabId: 1,
      },
    });
  }

  async refreshBorrowerCreditEvents({ applicationId, borrowerId }) {
    return this.#http.post(
      `/application/${applicationId}/borrowers/${borrowerId}/credit-events/refresh`,
    );
  }

  async inviteCoBorrower({ applicationId, borrowerId, email, createSeparateApplication }) {
    return this.#http.post(`/application/${applicationId}/borrower/${borrowerId}/invite`, {
      email,
      createSeparateApplication,
    });
  }
}
